var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoMenu01Active(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_13075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.21 11.9H13.63C12.79 11.9 12.11 11.22 12.11 10.38V6.78996C12.11 6.07996 11.78 5.40996 11.22 4.97996C10.69 4.55996 9.98996 4.40996 9.32996 4.56996C4.85996 5.66996 2.13996 10.2 3.24996 14.67C4.02996 17.82 6.56996 20.23 9.75996 20.85C14.11 21.68 18.36 18.98 19.44 14.68C19.61 14.02 19.46 13.32 19.03 12.79C18.59 12.23 17.92 11.9 17.21 11.9ZM17.96 14.31C17.05 17.97 13.35 20.19 9.69996 19.29C6.03996 18.38 3.81996 14.68 4.71996 11.03C5.32996 8.57996 7.24996 6.65996 9.69996 6.04996C9.89996 5.99996 10.12 6.04996 10.28 6.17996C10.47 6.32996 10.58 6.54996 10.58 6.78996V10.38C10.58 12.06 11.94 13.42 13.62 13.42H17.2C17.44 13.42 17.67 13.53 17.82 13.72C17.95 13.88 18 14.1 17.95 14.3L17.96 14.31Z",
    fill: "#242628"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9701 8.43C20.2601 5.82 18.2101 3.77 15.5901 3.05C15.4601 3.02 15.3201 3 15.1801 3C14.3401 3 13.6501 3.67 13.6401 4.51C13.6401 4.51 13.6401 4.51 13.6401 4.52V8.09C13.6401 9.35 14.6601 10.37 15.9201 10.37H19.5101C20.3501 10.37 21.0301 9.67 21.0201 8.83C21.0201 8.69 21.0001 8.56 20.9601 8.43H20.9701ZM19.0701 8.86H15.9201C15.5001 8.86 15.1601 8.52 15.1601 8.1V4.53C15.1601 4.53 15.1601 4.53 15.1701 4.53H15.1901C17.3001 5.1 18.9401 6.76 19.5101 8.87H19.0701V8.86Z",
    fill: "#242628"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_13075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.03,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMenu01Active);
export default __webpack_public_path__ + "static/media/ico-menu-01-active.d41f09de4e462d9d922e8a2f56efbde8.svg";
export { ForwardRef as ReactComponent };